import React from "react";

const Tab = props => {
    const {className, tab, disabled = false, activeTab, ...other} = props;

    return (
        <div className={'ch-tab' + (disabled ? ' ch-tab-disabled' : '') + (className ? ' ' + className : '')} {...other}>{tab}</div>
    )
}

export default Tab;